/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';

import { useStyles, ThemedStyleFn } from '~src/hooks/useStyles';
import IconButton, {
  IconButtonProps,
} from '~components/_common/IconButton/IconButton';

interface ModalTitleProps {
  text: string;
  icon: IconButtonProps['icon'];
  iconButtonProps?: Partial<IconButtonProps>;
}
export const ModalTitle: React.FC<ModalTitleProps> = ({
  text,
  icon,
  iconButtonProps,
}) => {
  const style = useStyles(styleFn);

  return (
    <div css={style.titleContainer}>
      <IconButton
        icon={icon}
        customStyle={style.titleBtn}
        backgroundOff
        {...iconButtonProps}
      />
      {text}
    </div>
  );
};

const styleFn: ThemedStyleFn = (theme) => ({
  titleBtn: {
    color: theme.colors.secondary,
    fontSize: '20px',
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontSize: '18px',
    fontWeight: 'bold',
  },
});
